import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "16",
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.1901 2.99295C3.02618 2.99295 2.86898 3.05806 2.75307 3.17397C2.63716 3.28988 2.57205 3.44708 2.57205 3.611V12.0078L3.98918 10.5906C4.10509 10.4747 4.26229 10.4096 4.42621 10.4096H11.8429C12.0068 10.4096 12.164 10.3445 12.2799 10.2286C12.3958 10.1127 12.4609 9.95546 12.4609 9.79154V3.611C12.4609 3.44708 12.3958 3.28988 12.2799 3.17397C12.164 3.05806 12.0068 2.99295 11.8429 2.99295H3.1901ZM1.87901 2.29991C2.22673 1.95218 2.69835 1.75684 3.1901 1.75684H11.8429C12.3346 1.75684 12.8062 1.95218 13.154 2.29991C13.5017 2.64763 13.697 3.11924 13.697 3.611V9.79154C13.697 10.2833 13.5017 10.7549 13.154 11.1026C12.8062 11.4504 12.3346 11.6457 11.8429 11.6457H4.68222L2.39102 13.9369C2.21426 14.1137 1.94842 14.1665 1.71747 14.0709C1.48652 13.9752 1.33594 13.7499 1.33594 13.4999V3.611C1.33594 3.11924 1.53129 2.64763 1.87901 2.29991Z",
  fill: "#2B3951"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };